<template>
    <v-menu
        v-model="editing"
        transition="scale-transition"
        :close-on-content-click="false"
        :nudge-width="100"
        :disabled="!allowEditing"
        v-if="severities"
    >
        <template v-slot:activator="{ on }">
            <a :style="`color: ${severity.color} !important;`" v-on="on" v-text="severity.label"> </a>
        </template>
        <v-card>
            <v-card-text>
                <severity-selector v-model="editingValue" :label="$t('issues.attributes.severity')" type="value" />
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="editing = false" v-text="$t('buttons.cancel')" />
                <v-btn color="success" text @click="changeAttribute" v-text="$t('buttons.save')" />
            </v-card-actions>
        </v-card>
    </v-menu>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import severitySelector from '@/components/selectors/simple/severity';

export default {
    name: 'issue-severity',
    data: () => ({
        editing: false,
        editingValue: undefined,
    }),
    props: {
        issue: {},
        allowEditing: {
            default: true,
        },
        onlyEdit: {
            default: false,
        },
    },
    components: {
        severitySelector,
    },
    watch: {
        editing: function (e) {
            if (e) {
                this.editingValue = this.issue.severity;
            }
        },
    },
    computed: {
        ...mapGetters(['severities']),
        severity() {
            return this.severities.find((t) => t.value === this.issue.severity);
        },
    },
    methods: {
        ...mapActions(['updateIssue']),
        async changeAttribute(value) {
            if (this.onlyEdit) {
                this.$emit('update-attribute', { name: 'severity', value: this.editingValue });
                this.editing = false;
            } else {
                await this.updateIssue({
                    id: this.issue.id,
                    severity: this.editingValue,
                });

                this.editing = false;
                this.$emit('change-attribute-value');
            }
        },
    },
};
</script>
